document.addEventListener( "DOMContentLoaded", () => {
    mobileMenuToggler()
    showCredits()
    scrollTop()
}, false)

const mobileMenuToggler = () => {
    const HAMBURGUER = document.getElementById("hamburguer-icon")
    const MOBILE_MENU = document.getElementById("mobile-menu")
    if(HAMBURGUER != undefined ) {
        HAMBURGUER.addEventListener( "click", () => {
            HAMBURGUER.classList.toggle("open")
            MOBILE_MENU.classList.toggle("open")
            document.documentElement.classList.toggle('opened-menu')
        })
    }
}

const showCredits = () => {
    console.log("%c>XYZZY estudio web_", "font-weight: 200; font-size: 30px; color:white; background-color:#ff1a51; padding:40px;");
    console.log("Checkout our work on: https://www.xyzzyestudioweb.com")
}

window.addEventListener( 'scroll', () => {
    toggleScroller( 'scrollTop' )
})

const toggleScroller = ( el ) => {

    let scrollTop = document.getElementById( el )

    if( scrollTop != undefined ) {
        if (window.scrollY >= 300) {
            scrollTop.style.opacity = 1
        } else {
            scrollTop.style.opacity = 0
        }
    }
    
}

const scrollTop = () => {

    let scrollTop = document.getElementById( 'scrollTop' )

    if( scrollTop != undefined ) {
        scrollTop.addEventListener( 'click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth' 
            });
        })
    }
    
}